module.exports = __webpack_public_path__ + "img/Recognition.ae2a53b6.png";